import SettingFormItems, { SettingItem, SettingItems } from "../SettingFormItems";

type SettingsNames =
'bgColor' |
'bgImage' |
'bgSize' |
'bgPosition' |
'bgRepeat' |
'bgAttachment' |
'fontColor';

const productSettings: SettingItem<SettingsNames> [] = [
    {
        key: 'bgColor',
        name: 'Background Color',
        type: 'color',
    },
    {
        key: 'bgImage',
        name: 'Background Image',
        type: 'image',
    },
    {
        key: 'fontColor',
        name: 'Font Color',
        type: 'color',
    }
]

const bgImageSettings: SettingItem<SettingsNames> [] = [
  {
    key: 'bgSize',
    name: 'Background Size',
    type: 'select',
    options: [
      {
        name: 'None',
        value: ''
      },
      {
        name: 'Auto',
        value: 'auto'
      },
      {
        name: 'Cover',
        value: 'cover'
      },
      {
        name: 'Contain',
        value: 'contain'
      },
      {
        name: '100%',
        value: '100%'
      }
    ]
  },
  {
    key: 'bgPosition',
    name: 'Background Position',
    type: 'select',
    options: [
      {
        name: 'None',
        value: ''
      },
      {
        name: 'Center',
        value: 'center'
      },
      {
        name: 'Top',
        value: 'top'
      },
      {
        name: 'Bottom',
        value: 'bottom'
      },
      {
        name: 'Left',
        value: 'left'
      },
      {
        name: 'Right',
        value: 'right'
      }
    ]
  },
  {
    key: 'bgRepeat',
    name: 'Background Repeat',
    type: 'select',
    options: [
      {
        name: 'None',
        value: ''
      },
      {
        name: 'No Repeat',
        value: 'no-repeat'
      },
      {
        name: 'Repeat',
        value: 'repeat'
      },
      {
        name: 'Repeat X',
        value: 'repeat-x'
      },
      {
        name: 'Repeat Y',
        value: 'repeat-y'
      }
    ]
  },
  {
    key: 'bgAttachment',
    name: 'Background Attatchment',
    type: 'select',
    options: [
      {
        name: 'None',
        value: ''
      },
      {
        name: 'Scroll',
        value: 'scroll'
      },
      {
        name: 'Fixed',
        value: 'fixed'
      },
    ]
  }
]

const BackgroundSettings = ({
    settings,
    onChange,
}: {
    settings?: SettingItems<SettingsNames>;
    onChange: (key: string, value: string) => void;
}) => {
  return (
    <>
        <SettingFormItems
            settingItems={productSettings}
            settings={settings}
            onChange={onChange}
        />

        {settings?.bgImage && (
            <SettingFormItems
                settingItems={bgImageSettings}
                title="Background Image Settings"
                settings={settings}
                onChange={onChange}
            />
        )}
    </>
  )
}

export default BackgroundSettings